var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "100%" }, attrs: { id: "m-inbox" } },
    [
      _c(
        "v-card",
        { attrs: { elevation: "0" } },
        [
          _c(
            "v-card-actions",
            { staticStyle: { height: "70px!important" } },
            [
              _c(
                "v-tabs",
                {
                  staticClass: "no-transition",
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c(
                    "v-tab",
                    { key: "tab-t-u" },
                    [
                      _vm._v("Talks "),
                      _c(
                        "v-icon",
                        {
                          staticStyle: { "margin-left": "8px" },
                          attrs: { size: "20" },
                        },
                        [_vm._v("mdi-chat-processing-outline")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-tab",
                    { key: "tab-explainers-u" },
                    [
                      _vm._v("Explainers "),
                      _c(
                        "v-icon",
                        {
                          staticStyle: { "margin-left": "8px" },
                          attrs: { size: "20" },
                        },
                        [_vm._v("mdi-view-week-outline")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-tab",
                    { key: "tab-test-u" },
                    [
                      _vm._v("Test "),
                      _c(
                        "v-icon",
                        {
                          staticStyle: { "margin-left": "8px" },
                          attrs: { size: "20" },
                        },
                        [_vm._v("mdi-asterisk")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-tab",
                    { key: "tab-heroes-u" },
                    [
                      _vm._v("Heroes "),
                      _c(
                        "v-icon",
                        {
                          staticStyle: { "margin-left": "8px" },
                          attrs: { size: "20" },
                        },
                        [_vm._v("mdi-emoticon-happy")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            {
              staticClass: "ma-0 pa-0 mx-2",
              staticStyle: { "border-bottom": "green solid 0px" },
            },
            [
              _c(
                "v-card",
                {
                  staticClass: "ma-0 pa-0 scroll",
                  attrs: {
                    width: "100%",
                    elevation: "0",
                    height: _vm.winsize.height - 145,
                  },
                },
                [
                  _c(
                    "v-tabs-items",
                    {
                      staticClass: "mt-0",
                      model: {
                        value: _vm.tab,
                        callback: function ($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab",
                      },
                    },
                    [
                      _c(
                        "v-tab-item",
                        {
                          key: "tab-t-u",
                          attrs: {
                            transition: "fade-transition",
                            "reverse-transition": "fade-transition",
                          },
                        },
                        [_c("utils-talks-page")],
                        1
                      ),
                      _c(
                        "v-tab-item",
                        {
                          key: "tab-explainers-u",
                          attrs: {
                            transition: "fade-transition",
                            "reverse-transition": "fade-transition",
                          },
                        },
                        [_c("utils-explainers-page")],
                        1
                      ),
                      _c(
                        "v-tab-item",
                        {
                          key: "tab-test-u",
                          attrs: {
                            transition: "fade-transition",
                            "reverse-transition": "fade-transition",
                          },
                        },
                        [_c("utils-test-page")],
                        1
                      ),
                      _c(
                        "v-tab-item",
                        {
                          key: "tab-heroes-u",
                          attrs: {
                            transition: "fade-transition",
                            "reverse-transition": "fade-transition",
                          },
                        },
                        [_c("utils-heroes-page")],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }